export { default } from "./FormativeTOSModal";
